import { Link } from 'react-router-dom';
import { machineDetailPath } from '@/lib/entityPaths';
import { entityLinkClassName } from '@/lib/entityLink';
import { cn } from '@/lib/utils';

export interface MachineLinkProps {
  machineId: string;
  name: string;
  className?: string;
}

export function MachineLink({ machineId, name, className }: MachineLinkProps) {
  const label = name.trim() || 'Unnamed machine';
  return (
    <Link
      to={machineDetailPath(machineId)}
      className={cn(entityLinkClassName, className)}
    >
      {label}
    </Link>
  );
}
